import { render, staticRenderFns } from "./commodityThreeRow.vue?vue&type=template&id=2fdc8780&scoped=true&"
import script from "./commodityThreeRow.vue?vue&type=script&lang=js&"
export * from "./commodityThreeRow.vue?vue&type=script&lang=js&"
import style0 from "./commodityThreeRow.vue?vue&type=style&index=0&id=2fdc8780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc8780",
  null
  
)

export default component.exports